import { render } from "./SpmTableApi.vue?vue&type=template&id=5053ffb2"
import script from "./SpmTableApi.vue?vue&type=script&lang=ts"
export * from "./SpmTableApi.vue?vue&type=script&lang=ts"

import "./SpmTableApi.vue?vue&type=style&index=0&id=5053ffb2&lang=scss"
import "./SpmTableApi.vue?vue&type=style&index=1&id=5053ffb2&lang=scss"
script.render = render

export default script